/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SessionQuestProgress } from './SessionQuestProgress';
import {
    SessionQuestProgressFromJSON,
    SessionQuestProgressFromJSONTyped,
    SessionQuestProgressToJSON,
    SessionQuestProgressToJSONTyped,
} from './SessionQuestProgress';
import type { SessionAverageComparison } from './SessionAverageComparison';
import {
    SessionAverageComparisonFromJSON,
    SessionAverageComparisonFromJSONTyped,
    SessionAverageComparisonToJSON,
    SessionAverageComparisonToJSONTyped,
} from './SessionAverageComparison';
import type { SessionMilestone } from './SessionMilestone';
import {
    SessionMilestoneFromJSON,
    SessionMilestoneFromJSONTyped,
    SessionMilestoneToJSON,
    SessionMilestoneToJSONTyped,
} from './SessionMilestone';

/**
 * 
 * @export
 * @interface SessionInfo
 */
export interface SessionInfo {
    /**
     * ID of the first time-log in this session
     * @type {string}
     * @memberof SessionInfo
     */
    sessionId?: string;
    /**
     * Game ID from Overwolf
     * @type {string}
     * @memberof SessionInfo
     */
    gameId?: string;
    /**
     * Human-readable game name
     * @type {string}
     * @memberof SessionInfo
     */
    gameTitle?: string;
    /**
     * URL to game thumbnail image
     * @type {string}
     * @memberof SessionInfo
     */
    gameThumbnail?: string;
    /**
     * When the session ended
     * @type {Date}
     * @memberof SessionInfo
     */
    lastPlayed?: Date;
    /**
     * Session duration in minutes
     * @type {number}
     * @memberof SessionInfo
     */
    sessionDuration?: number;
    /**
     * Total XP earned in this session
     * @type {number}
     * @memberof SessionInfo
     */
    xpEarned?: number;
    /**
     * Total Fuel earned in this session
     * @type {number}
     * @memberof SessionInfo
     */
    fuelEarned?: number;
    /**
     * 
     * @type {number}
     * @memberof SessionInfo
     */
    questsCompleted?: number;
    /**
     * 
     * @type {Array<SessionQuestProgress>}
     * @memberof SessionInfo
     */
    questProgress?: Array<SessionQuestProgress>;
    /**
     * 
     * @type {Array<SessionMilestone>}
     * @memberof SessionInfo
     */
    milestonesReached?: Array<SessionMilestone>;
    /**
     * 
     * @type {SessionAverageComparison}
     * @memberof SessionInfo
     */
    averageComparison?: SessionAverageComparison;
}

/**
 * Check if a given object implements the SessionInfo interface.
 */
export function instanceOfSessionInfo(value: object): value is SessionInfo {
    return true;
}

export function SessionInfoFromJSON(json: any): SessionInfo {
    return SessionInfoFromJSONTyped(json, false);
}

export function SessionInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SessionInfo {
    if (json == null) {
        return json;
    }
    return {
        
        'sessionId': json['sessionId'] == null ? undefined : json['sessionId'],
        'gameId': json['gameId'] == null ? undefined : json['gameId'],
        'gameTitle': json['gameTitle'] == null ? undefined : json['gameTitle'],
        'gameThumbnail': json['gameThumbnail'] == null ? undefined : json['gameThumbnail'],
        'lastPlayed': json['lastPlayed'] == null ? undefined : (new Date(json['lastPlayed'])),
        'sessionDuration': json['sessionDuration'] == null ? undefined : json['sessionDuration'],
        'xpEarned': json['xpEarned'] == null ? undefined : json['xpEarned'],
        'fuelEarned': json['fuelEarned'] == null ? undefined : json['fuelEarned'],
        'questsCompleted': json['questsCompleted'] == null ? undefined : json['questsCompleted'],
        'questProgress': json['questProgress'] == null ? undefined : ((json['questProgress'] as Array<any>).map(SessionQuestProgressFromJSON)),
        'milestonesReached': json['milestonesReached'] == null ? undefined : ((json['milestonesReached'] as Array<any>).map(SessionMilestoneFromJSON)),
        'averageComparison': json['averageComparison'] == null ? undefined : SessionAverageComparisonFromJSON(json['averageComparison']),
    };
}

export function SessionInfoToJSON(json: any): SessionInfo {
    return SessionInfoToJSONTyped(json, false);
}

export function SessionInfoToJSONTyped(value?: SessionInfo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'sessionId': value['sessionId'],
        'gameId': value['gameId'],
        'gameTitle': value['gameTitle'],
        'gameThumbnail': value['gameThumbnail'],
        'lastPlayed': value['lastPlayed'] == null ? undefined : ((value['lastPlayed']).toISOString()),
        'sessionDuration': value['sessionDuration'],
        'xpEarned': value['xpEarned'],
        'fuelEarned': value['fuelEarned'],
        'questsCompleted': value['questsCompleted'],
        'questProgress': value['questProgress'] == null ? undefined : ((value['questProgress'] as Array<any>).map(SessionQuestProgressToJSON)),
        'milestonesReached': value['milestonesReached'] == null ? undefined : ((value['milestonesReached'] as Array<any>).map(SessionMilestoneToJSON)),
        'averageComparison': SessionAverageComparisonToJSON(value['averageComparison']),
    };
}

